<template>
  <div>
    <h2>Usages</h2>
    <div
      class="col-100 recherche-avancee-grid recherche-avancee-produits-usage"
    >
      <div class="usage-code">
        <label for="usage-code" class="label-bold">Code usage</label>
        <input
          :value="ephyCode"
          @change="$emit('update:ephyCode', $event.target.value)"
          type="text"
          id="usage-code"
        />
      </div>

      <div class="usage-cultures">
        <label for="usage-cultures" class="label-bold">Cultures</label>
        <div>
          <div
            class="relative"
            v-for="(cultivation, index) in cultivations"
            :key="index"
          >
            <select
              :value="cultivation"
              @change="
                $emit(
                  'update:cultivations',
                  cultivations.map((x, ind) =>
                    ind === index ? $event.target.value : x
                  )
                )
              "
              id="usage-cultures"
            >
              <option value="">Toutes</option>
              <option
                v-for="cultivation in cultivationsList"
                :key="cultivation"
                :value="cultivation"
              >
                {{ cultivation }}
              </option>
            </select>
            <div
              v-if="index === cultivations.length - 1"
              class="ajout-element"
              @click="$emit('update:cultivations', cultivations.concat(['']))"
            ></div>
            <div
              v-else
              class="suppr-element"
              @click="
                $emit(
                  'update:cultivations',
                  cultivations.filter((value, i) => i !== index)
                )
              "
            ></div>
          </div>
        </div>
      </div>

      <div class="usage-cibles">
        <label for="usage-cibles" class="label-bold">Cibles</label>
        <div>
          <div class="relative" v-for="(target, index) in targets" :key="index">
            <select
              :value="target"
              @change="
                $emit(
                  'update:targets',
                  targets.map((x, ind) =>
                    ind === index ? $event.target.value : x
                  )
                )
              "
              id="usage-cibles"
            >
              <option value="">Toutes</option>
              <option
                v-for="target in targetsList"
                :key="target"
                :value="target"
              >
                {{ target }}
              </option>
            </select>
            <div
              v-if="index === targets.length - 1"
              class="ajout-element"
              @click="$emit('update:targets', targets.concat(['']))"
            ></div>
            <div
              v-else
              class="suppr-element"
              @click="
                $emit(
                  'update:targets',
                  targets.filter((value, i) => i !== index)
                )
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsesForm',

  props: {
    ephyCode: String,
    applicationStartDay: String,
    applicationStartMonth: String,
    applicationEndDay: String,
    applicationEndMonth: String,
    bbchMin: String,
    bbchMinOperator: String,
    bbchMax: String,
    bbchMaxOperator: String,
    dar: String,
    darOperator: String,
    dre: String,
    dreOperator: String,
    iznt: String,
    izntOperator: String,
    zntArthro: String,
    zntArthroOperator: String,
    zntPlant: String,
    zntPlantOperator: String,
    cultivationsList: Array,
    cultivations: Array,
    targetsList: Array,
    targets: Array
  },

  data () {
    return {
      applicationStart: '',
      applicationEnd: ''
    }
  },

  created () {
    let year = new Date().getFullYear()
    this.applicationStart = `${year}-${this.applicationStartMonth}-${this.applicationStartDay}`
    this.applicationEnd = `${year}-${this.applicationEndMonth}-${this.applicationEndDay}`
  },

  methods: {
    setApplicationStart () {
      this.$emit(
        'update:applicationStartDay',
        this.applicationStart.split('-')[2]
      )
      this.$emit(
        'update:applicationStartMonth',
        this.applicationStart.split('-')[1]
      )
    },

    setApplicationEnd () {
      this.$emit('update:applicationEndDay', this.applicationEnd.split('-')[2])
      this.$emit(
        'update:applicationEndMonth',
        this.applicationEnd.split('-')[1]
      )
    }
  }
}
</script>
